import { render, staticRenderFns } from "./DocListAdvanceSearch.component.vue?vue&type=template&id=52deb39d"
import script from "./DocListAdvanceSearch.component.vue?vue&type=script&lang=js"
export * from "./DocListAdvanceSearch.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports